const translations = {
  "en": {
    "· Ends on %{date}": "· Ends on %{date}",
    "· Next Payment:": "· Next Payment:",
    "· Payment failed": "· Payment failed",
    "· Renews on %{date}": "· Renews on %{date}",
    "Cancel Subscription": "Cancel Subscription",
    "Manage": "Manage",
    "Manage on Apple": "Manage on Apple",
    "Manage on google": "Manage on google",
    "No auto-renewing subscriptions": "No auto-renewing subscriptions"
  },
  "zh-tw": {
    "· Ends on %{date}": "· 截止於 %{date}",
    "· Next Payment:": "· 下次付款：",
    "· Payment failed": "· 付款失敗",
    "· Renews on %{date}": "· 於 %{date} 續訂",
    "Cancel Subscription": "取消訂閱",
    "Manage": "管理",
    "Manage on Apple": "在 Apple 管理",
    "Manage on google": "在 Google 管理",
    "No auto-renewing subscriptions": "無自動續訂項目"
  }
};

export default translations;
